'use client'

import cx from 'classnames'
import dynamic from 'next/dynamic'
import { FC, ReactNode } from 'react'

const LoadingMaskLogic = dynamic(() => import('@/components/Top/LoadingMask/LoadingMaskLogic'), {
  ssr: true,
})

type Props = {
  children: ReactNode
}

const LoadingMask: FC<Props> = ({ children }) => {
  return (
    <>
      <LoadingMaskLogic>
        {({ start, completed, invisible }) => {
          return (
            <div
              className={cx('p-loading', {
                'is-start': start,
                'is-completed': completed,
                'is-invisible': invisible,
              })}
              id="p-loading"
            >
              {children}
            </div>
          )
        }}
      </LoadingMaskLogic>
    </>
  )
}

export default LoadingMask
